module.exports = __webpack_public_path__ + "img/paragraph.b4fa9760.svg";